import type {ReactElement} from 'react';
import React from 'react';
import {ItemBaseAlignmentOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-base-alignment-option';
import type {TextHorizontalAlignType} from '@PosterWhiteboard/classes/text-styles.class';
import {LayoutTypes} from '@PosterWhiteboard/items/layouts/layout.types';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTextStylesActiveItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesActiveItem';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';

interface ItemAlignmentOptionProps {
  showLargeIcons?: boolean;
  text?: string;
}

export function ItemAlignmentOption({showLargeIcons = false, ...props}: ItemAlignmentOptionProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const textAlign = useGetKeyFromTextStylesActiveItem('textAlign');
  const layoutStyle = useGetKeyFromTableItem('layoutStyle') as LayoutTypes | undefined;

  if (!activeItem || (activeItem && !('textStyles' in activeItem)) || textAlign === undefined) {
    throw new Error(`Item doesn't have textStyles property`);
  }
  const onClickHandler = (clickedId: TextHorizontalAlignType): void => {
    void activeItem.updateFromObject({
      textStyles: {
        textAlign: clickedId,
      },
    });
  };

  if (activeItem.isSchedule() && activeItem.isTableItem() && layoutStyle !== undefined && layoutStyle !== LayoutTypes.TABLE_LAYOUT) {
    return null;
  }

  return <ItemBaseAlignmentOption text={props.text} showLargeIcons={showLargeIcons} onClickAlignmentOption={onClickHandler} selectedAlignment={textAlign} />;
}
